// API Configuration
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (typeof window !== "undefined" && window.location.origin
    ? `${window.location.origin}/api`
    : "http://localhost:5001");

export default API_BASE_URL;
